import { AnyZodObject } from "zod";
import CheckinEntryFormStepCompleted from "../components/directivesFormSteps/CheckinEntryFormStep/states/CheckinEntryFormStepCompleted";
import CheckinEntryFormStepPending from "../components/directivesFormSteps/CheckinEntryFormStep/states/CheckinEntryFormStepPending";
import EstablishmentChoiceEntryFormStepCompleted from "../components/directivesFormSteps/EstablishmentChoiceEntryFormStep/states/EstablishmentChoiceEntryFormStepCompleted";
import EstablishmentChoiceEntryFormStepPending from "../components/directivesFormSteps/EstablishmentChoiceEntryFormStep/states/EstablishmentChoiceEntryFormStepPending";
import { checkinEntrySchema, directiveComplexitySchema, establishmentChoiceEntrySchema } from "../schemas/maintenanceForwardingDirectiveSteps.schema";
import { MaintenanceForwardingsDirectiveFormStepProps } from "../types/maintenanceforwardingsDirectiveFormStep.type";
import { MaintenanceForwardingsDirectiveFromSteps, MaintenanceForwardingsRequiredDirectiveStepsData } from "../types/maintenanceForwardingsShowDirectiveDetails.type";
import { checkinEntryOptions } from "./directiveEntryFormSteps/checkinEntry/checkinEntryOptions.constant";
import { establishmentChoiceEntryOptions } from "./directiveEntryFormSteps/establishmentChoiceEntry/establishmentChoiceEntryOptions.constant";
import DirectiveComplexityFormStepPending from "../components/directivesFormSteps/DirectiveComplexityFormStep/states/DirectiveComplexityFormStepPending";
import DirectiveComplexityFormStepCompleted from "../components/directivesFormSteps/DirectiveComplexityFormStep/states/DirectiveComplexityFormStepCompleted";

export const directiveEntryFormSteps: {
  [K in keyof MaintenanceForwardingsRequiredDirectiveStepsData]: {
    components: {
      pending: React.ComponentType<MaintenanceForwardingsDirectiveFormStepProps<K>>;
      completed: React.ComponentType<MaintenanceForwardingsDirectiveFormStepProps<K>>;
    };
    options: any;
    schema: AnyZodObject;
  }
} = {
  [MaintenanceForwardingsDirectiveFromSteps.DirectiveComplexity]: {
    components: {
      pending: DirectiveComplexityFormStepPending,
      completed: DirectiveComplexityFormStepCompleted,
    },
    options: null,
    schema: directiveComplexitySchema,
  },
  [MaintenanceForwardingsDirectiveFromSteps.EstablishmentChoiceEntry]: {
    components: {
      pending: EstablishmentChoiceEntryFormStepPending,
      completed: EstablishmentChoiceEntryFormStepCompleted,
    },
    options: establishmentChoiceEntryOptions,
    schema: establishmentChoiceEntrySchema,
  },
  [MaintenanceForwardingsDirectiveFromSteps.CheckinEntry]: {
    components: {
      pending: CheckinEntryFormStepPending,
      completed: CheckinEntryFormStepCompleted,
    },
    options: checkinEntryOptions,
    schema: checkinEntrySchema,
  },
}
